import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import Tenscribe from "../Assets/Tenscribe.png";
import kabra from "../Assets/kabra.png";
import Festa from "../Assets/Festa.png";
import semicon from "../Assets/semicon.png";
import feston from "../Assets/feston.png";
import lix from "../Assets/lix.png";
import guru from "../Assets/guru.png";
import massive from "../Assets/massive.png";
import fesren from "../Assets/fesren.png";
import softsuave from "../Assets/softsuave.png";
import bec from "../Assets/bec.png";
import postulate from "../Assets/postulate.png";

const customers = [
  { name: "Tescribe Consulting", logo: Tenscribe },
  { name: "Kabra Emporium", logo: kabra },
  { name: "Festa Solar Pvt Ltd", logo: Festa },
  { name: "BEC", logo: bec },
  { name: "Fesren Energy Pvt Ltd", logo: fesren },
  { name: "Semicon Solar Pvt Ltd", logo: semicon },
  { name: "Feston S.E.V Pvt Ltd", logo: feston },
  { name: "Soft Suave Technologies", logo: softsuave },
  { name: "Postulate Info-Tech", logo: postulate },
  { name: "Lix Furnishing", logo: lix },
  { name: "Guru Electricals", logo: guru },
  { name: "Massive Constructions", logo: massive },
];

export default function CustomerSlider() {
  return (
    <section className="py-16 bg-[#F6AE1B]"> {/* 🔆 Updated background color */}
      <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
        Our Proud Customers
      </h2>

      <Swiper
        modules={[Autoplay]}
        slidesPerView={5}
        spaceBetween={30}
        loop={true}
        speed={3000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        freeMode={true}
        grabCursor={true}
        className="max-w-7xl mx-auto"
        breakpoints={{
          320: { slidesPerView: 2 },
          640: { slidesPerView: 3 },
          1024: { slidesPerView: 5 },
        }}
      >
        {customers.map((c, idx) => (
          <SwiperSlide key={idx}>
            <div className="flex flex-col items-center py-6">
              <img
                src={c.logo}
                alt={c.name}
                className="h-20 w-auto object-contain mb-2"
              />
              <p className="text-sm text-gray-700 text-center">{c.name}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
